import React from 'react';
import { formatDate } from '@/utils/projectUi';
import type { MemberLog } from '../types/memberDetail.types';

interface MemberHistoryBlockProps {
  logs: MemberLog[];
  isLoading?: boolean;
}

export function MemberHistoryBlock({ logs, isLoading }: MemberHistoryBlockProps) {
  if (isLoading) {
    return (
      <div className="animate-pulse rounded-md border border-slate-100 bg-white p-3 shadow-sm space-y-2">
        <div className="h-4 w-32 rounded bg-slate-50" />
        <div className="space-y-4">
          {[1, 2, 3].map(i => (
            <div key={i} className="flex gap-3">
              <div className="h-8 w-8 rounded-full bg-slate-50" />
              <div className="flex-1 space-y-2">
                <div className="h-3 w-3/4 rounded bg-slate-50" />
                <div className="h-2 w-1/4 rounded bg-slate-50" />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-md border border-slate-100 bg-white p-3 shadow-sm space-y-2">
      <h2 className="text-sm font-medium text-slate-900 flex items-center gap-2">
        <i className="ri-history-line text-blue-600" />
        Lịch sử hoạt động
      </h2>

      <div className="relative space-y-2 before:absolute before:left-4 before:top-2 before:h-[calc(100%-16px)] before:w-0.5 before:bg-slate-50">
        {logs.map((log) => (
          <div key={log.id} className="relative pl-10">
            <div className="absolute left-2.5 top-1 h-3 w-3 rounded-full border-2 border-white bg-blue-500 shadow-sm" />
            <div className="flex flex-col">
              <span className="text-xs font-medium text-slate-700">{log.action}</span>
              <span className="text-xs font-medium text-slate-400 mt-0.5">
                {formatDate(log.timestamp)} • {new Date(log.timestamp).toLocaleTimeString('vi-VN', { hour: '2-digit', minute: '2-digit' })}
              </span>
            </div>
          </div>
        ))}
        {logs.length === 0 && (
          <div className="py-8 text-center text-xs text-slate-400 italic">
            Chưa có ghi chép hoạt động nào
          </div>
        )}
      </div>
    </div>
  );
}
